import { HTMLAttributes } from 'react';

import {
  Typography,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    marginBottom: 'var(--bui-space-1)',
  },
  label: {
    marginBottom: 'var(--bui-space-2)',
  },
});

export interface ActivityItemSectionProps
  extends HTMLAttributes<HTMLDivElement>,
    WithStyles<typeof styles> {
  label: string;
}

const ActivityItemSection = (props: ActivityItemSectionProps) => {
  const { label, children, className, classes, ...rest } = props;

  return (
    <div className={classNames(classes.root, className)} {...rest}>
      <Typography
        className={classNames({
          [classes.label]: children,
        })}
        variant="body2"
        color="textSecondary"
      >
        {label}
      </Typography>
      {children}
    </div>
  );
};

export default withStyles(styles)(ActivityItemSection);
